/** Shared column definitions for resizable data tables (widths persisted via useTableColumnResize). */

const USERS_ORGS_SORT_BTN = 'connector-openvas-assignment-sort-btn users-orgs-sort-btn';
const USERS_ORGS_SORT_ICON = 'connector-openvas-assignment-sort-icon';

export const ASSETS_INVENTORY_TABLE_COLUMNS = [
  {
    key: 'checkbox',
    label: 'Select',
    sortKey: null,
    resizable: false,
    defaultWidth: 44,
    minWidth: 44,
    maxWidth: 44,
    centerHeader: true,
    thClassName: 'risks-page-th-checkbox assets-th-checkbox',
  },
  {
    key: 'site',
    label: 'Organization / Site',
    sortKey: 'orgSite',
    resizable: true,
    defaultWidth: 200,
    minWidth: 150,
    thClassName: 'assets-th-orgsite',
  },
  { key: 'ipAddress', label: 'IP Address', sortKey: 'ipAddress', resizable: true, defaultWidth: 150, minWidth: 110 },
  { key: 'hostname', label: 'Hostname', sortKey: 'hostname', resizable: true, defaultWidth: 200, minWidth: 120 },
  { key: 'type', label: 'Type', sortKey: 'type', resizable: true, defaultWidth: 130, minWidth: 110 },
  { key: 'macAddress', label: 'MAC Address', sortKey: 'macAddress', resizable: true, defaultWidth: 170, minWidth: 140 },
  {
    key: 'certificates',
    label: 'Certificates',
    sortKey: 'certificates',
    resizable: true,
    defaultWidth: 130,
    minWidth: 110,
    thClassName: 'assets-th-certificates',
  },
  {
    key: 'action',
    label: 'Action',
    sortKey: null,
    resizable: false,
    defaultWidth: 84,
    minWidth: 84,
    maxWidth: 100,
    centerHeader: false,
  },
];
export const ASSETS_INVENTORY_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_assets_inventory_table_column_widths_v10';

export const CONNECTORS_TABLE_COLUMNS = [
  { key: 'name', label: 'Connector', sortKey: 'name', defaultWidth: 220, minWidth: 140 },
  { key: 'assignment', label: 'Location', sortKey: 'assignmentSummary', defaultWidth: 180, minWidth: 140 },
  { key: 'orgSite', label: 'Organization / Site', sortKey: 'orgSite', defaultWidth: 260, minWidth: 180 },
  { key: 'status', label: 'Status', sortKey: 'status', defaultWidth: 150, minWidth: 110 },
  { key: 'lastUpdated', label: 'Last updated', sortKey: 'lastUpdated', defaultWidth: 160, minWidth: 110 },
  {
    key: 'actions',
    label: 'Actions',
    sortKey: null,
    resizable: false,
    defaultWidth: 240,
    minWidth: 230,
    maxWidth: 260,
    thClassName: 'connectors-settings-th-actions',
  },
];
export const CONNECTORS_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_connectors_table_column_widths_v5';

export const SITES_TABLE_COLUMNS = [
  { key: 'name', label: 'Site', sortKey: 'name', defaultWidth: 200, minWidth: 120 },
  { key: 'orgName', label: 'Organization', sortKey: 'orgName', defaultWidth: 220, minWidth: 140 },
  { key: 'description', label: 'Description', sortKey: 'description', defaultWidth: 220, minWidth: 120 },
  { key: 'status', label: 'Status', sortKey: 'status', defaultWidth: 120, minWidth: 90 },
  { key: 'isActive', label: 'Active', sortKey: 'isActive', defaultWidth: 100, minWidth: 80 },
  {
    key: 'actions',
    label: 'Actions',
    sortKey: null,
    resizable: false,
    defaultWidth: 100,
    minWidth: 90,
    maxWidth: 120,
    thClassName: 'users-orgs-settings-th-actions connectors-settings-th-actions',
  },
];
export const SITES_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_sites_table_column_widths_v2';

export const PARTNERS_TABLE_COLUMNS = [
  { key: 'name', label: 'Name', sortKey: 'name', defaultWidth: 160, minWidth: 100 },
  { key: 'email', label: 'Email', sortKey: 'email', defaultWidth: 200, minWidth: 120 },
  { key: 'referral', label: 'Referral code', sortKey: 'referral', defaultWidth: 140, minWidth: 100 },
  { key: 'tier', label: 'Tier', sortKey: 'tier', defaultWidth: 100, minWidth: 72 },
  { key: 'commission', label: 'Commission', sortKey: 'commission', defaultWidth: 120, minWidth: 90 },
  { key: 'clients', label: 'Clients', sortKey: 'clients', defaultWidth: 90, minWidth: 72 },
  {
    key: 'actions',
    label: 'Actions',
    sortKey: null,
    resizable: false,
    defaultWidth: 150,
    minWidth: 130,
    maxWidth: 180,
    centerHeader: false,
    thClassName: 'partners-settings-th-actions connectors-settings-th-actions',
  },
];
export const PARTNERS_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_partners_table_column_widths_v3';

export const GHOST_EXPOSURE_TABLE_COLUMNS = [
  { key: 'cveId', label: 'CVE ID', sortKey: 'cveId', defaultWidth: 130, minWidth: 100 },
  { key: 'status', label: 'Status', sortKey: 'status', defaultWidth: 110, minWidth: 80 },
  { key: 'asset', label: 'Asset', sortKey: 'asset', defaultWidth: 160, minWidth: 100 },
  { key: 'site', label: 'Site', sortKey: 'site', defaultWidth: 140, minWidth: 90 },
  { key: 'exposureLevel', label: 'Exposure Level', sortKey: 'exposureLevel', defaultWidth: 130, minWidth: 90 },
  { key: 'internetFacing', label: 'Internet-Facing', sortKey: 'internetFacing', defaultWidth: 130, minWidth: 90, centerHeader: true, thClassName: 'assets-cell-center' },
  { key: 'confidence', label: 'Match Confidence', sortKey: 'confidence', defaultWidth: 120, minWidth: 90, centerHeader: true, thClassName: 'assets-cell-center' },
  { key: 'detected', label: 'Detected', sortKey: 'detected', defaultWidth: 130, minWidth: 100 },
  { key: 'notified', label: 'Notified', sortKey: 'notified', defaultWidth: 90, minWidth: 72, centerHeader: true, thClassName: 'assets-cell-center' },
];
export const GHOST_EXPOSURE_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_ghost_exposure_table_column_widths_v2';

export const EARLY_DISCLOSURE_TABLE_COLUMNS = [
  { key: 'productHint', label: 'Product Hint', sortKey: 'productHint', defaultWidth: 180, minWidth: 100 },
  { key: 'cveId', label: 'CVE ID', sortKey: 'cveId', defaultWidth: 130, minWidth: 100 },
  { key: 'status', label: 'Registry Status', sortKey: 'status', defaultWidth: 130, minWidth: 110 },
  { key: 'confidence', label: 'Confidence', sortKey: 'confidence', defaultWidth: 110, minWidth: 80 },
  { key: 'firstSeen', label: 'First Seen', sortKey: 'firstSeen', defaultWidth: 130, minWidth: 100 },
  { key: 'daysOld', label: 'Days Old', sortKey: 'daysOld', defaultWidth: 100, minWidth: 72 },
  { key: 'affectedAssets', label: 'Affected Assets', sortKey: 'affectedAssets', defaultWidth: 130, minWidth: 90, centerHeader: true, thClassName: 'assets-cell-center' },
  { key: 'unnotified', label: 'Unnotified', sortKey: 'unnotified', defaultWidth: 110, minWidth: 80, centerHeader: true, thClassName: 'assets-cell-center' },
];
export const EARLY_DISCLOSURE_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_early_disclosure_table_column_widths_v2';

export const VULN_TABLE_COLUMNS = [
  { key: 'title', label: 'TITLE', sortKey: 'title', defaultWidth: 360, minWidth: 160, sortButtonClassName: 'vuln-sort-btn', sortIconClassName: 'vuln-sort-icon' },
  { key: 'severity', label: 'SEVERITY', sortKey: 'severity', defaultWidth: 120, minWidth: 90, sortButtonClassName: 'vuln-sort-btn', sortIconClassName: 'vuln-sort-icon' },
  { key: 'count', label: 'COUNT', sortKey: 'count', defaultWidth: 90, minWidth: 72, sortButtonClassName: 'vuln-sort-btn', sortIconClassName: 'vuln-sort-icon' },
];
export const VULN_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_vuln_table_column_widths';

export const SCAN_DETAIL_VULN_TABLE_COLUMNS = [
  { key: 'severity', label: 'Threat', sortKey: 'severity', defaultWidth: 100, minWidth: 80 },
  { key: 'target', label: 'Target', sortKey: 'target', defaultWidth: 180, minWidth: 100 },
  { key: 'title', label: 'Vulnerability', sortKey: 'title', defaultWidth: 280, minWidth: 140 },
  { key: 'scanner', label: 'Scanner', sortKey: 'scanner', defaultWidth: 120, minWidth: 96 },
  { key: 'status', label: 'Status', sortKey: 'status', defaultWidth: 140, minWidth: 112 },
];
export const SCAN_DETAIL_VULN_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_scan_detail_vuln_table_column_widths';

export const ASSET_DETAIL_CERT_TABLE_COLUMNS = [
  { key: 'subject', label: 'Common Name', sortKey: 'subject', defaultWidth: 160, minWidth: 100 },
  { key: 'sans', label: 'SANs', sortKey: 'sans', defaultWidth: 140, minWidth: 90 },
  { key: 'issuer', label: 'Issuer', sortKey: 'issuer', defaultWidth: 120, minWidth: 90 },
  { key: 'not_valid_before', label: 'Valid From', sortKey: 'not_valid_before', defaultWidth: 130, minWidth: 100 },
  { key: 'not_valid_after', label: 'Expiry Date', sortKey: 'not_valid_after', defaultWidth: 130, minWidth: 100 },
  { key: 'ports', label: 'Applied to port(s)', sortKey: 'ports', defaultWidth: 120, minWidth: 90 },
];
export const ASSET_DETAIL_CERT_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_asset_detail_cert_table_column_widths';

export const ASSET_DETAIL_VULN_TABLE_COLUMNS = [
  { key: 'title', label: 'Name', sortKey: 'title', defaultWidth: 220, minWidth: 120 },
  { key: 'date_time', label: 'Time stamp', sortKey: 'date_time', defaultWidth: 150, minWidth: 110 },
  { key: 'severity', label: 'Severity', sortKey: 'severity', defaultWidth: 100, minWidth: 80 },
  { key: 'cvss_score', label: 'CVSS Score', sortKey: 'cvss_score', defaultWidth: 100, minWidth: 72 },
  { key: 'port', label: 'Port', sortKey: 'port', defaultWidth: 80, minWidth: 64 },
];
export const ASSET_DETAIL_VULN_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_asset_detail_vuln_table_column_widths';

export const MANAGE_USERS_TABLE_COLUMNS = [
  {
    key: 'checkbox',
    label: '',
    sortKey: null,
    resizable: false,
    defaultWidth: 44,
    minWidth: 44,
    centerHeader: true,
    thClassName: 'risks-page-th-checkbox assets-th-checkbox users-orgs-settings-th-checkbox',
  },
  { key: 'name', label: 'Name', sortKey: 'name', defaultWidth: 160, minWidth: 100 },
  { key: 'email', label: 'Email', sortKey: 'email', defaultWidth: 200, minWidth: 120 },
  { key: 'role', label: 'Role', sortKey: 'role', defaultWidth: 110, minWidth: 80 },
  { key: 'organization', label: 'Organization', sortKey: 'organization', defaultWidth: 160, minWidth: 100 },
  {
    key: 'actions',
    label: 'Actions',
    sortKey: null,
    resizable: false,
    defaultWidth: 190,
    minWidth: 170,
    maxWidth: 240,
    centerHeader: false,
    thClassName: 'manage-users-th-actions assets-th-action',
  },
];
export const MANAGE_USERS_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_manage_users_table_column_widths_v6';

export const FAQ_TABLE_COLUMNS = [
  { key: 'question', label: 'Question', sortKey: 'question', defaultWidth: 280, minWidth: 140 },
  { key: 'answer', label: 'Answer', sortKey: 'answer', defaultWidth: 360, minWidth: 160 },
];
export const FAQ_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_faq_table_column_widths';

export const INTEGRATIONS_TABLE_COLUMNS = [
  { key: 'name', label: 'Name', sortKey: 'name', defaultWidth: 200, minWidth: 100 },
  { key: 'description', label: 'Description', sortKey: 'description', defaultWidth: 320, minWidth: 140 },
];
export const INTEGRATIONS_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_integrations_table_column_widths';

export const CONNECTOR_ASSIGNMENT_TABLE_COLUMNS = [
  {
    key: 'enabled',
    label: 'Enabled',
    sortKey: null,
    resizable: false,
    defaultWidth: 110,
    minWidth: 96,
    centerHeader: true,
    thClassName: 'assets-cell-center',
  },
  { key: 'org', label: 'Organization', sortKey: 'org', defaultWidth: 200, minWidth: 120 },
  { key: 'site', label: 'Site', sortKey: 'site', defaultWidth: 200, minWidth: 120 },
];
export const CONNECTOR_ASSIGNMENT_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_connector_assignment_table_column_widths_v2';
export const CONNECTOR_ASSIGNMENT_OPENVAS_COLUMN_WIDTHS_KEY = 'xspectre_connector_assignment_openvas_column_widths_v2';
export const CONNECTOR_ASSIGNMENT_ZAP_COLUMN_WIDTHS_KEY = 'xspectre_connector_assignment_zap_column_widths_v2';

export const XDR_INTEGRATION_TABLE_COLUMNS = [
  { key: 'name', label: 'Name', sortKey: null, defaultWidth: 160, minWidth: 100 },
  { key: 'provider', label: 'Provider', sortKey: null, defaultWidth: 120, minWidth: 80 },
  { key: 'baseUrl', label: 'Base URL', sortKey: null, defaultWidth: 220, minWidth: 120 },
  { key: 'status', label: 'Status', sortKey: null, defaultWidth: 110, minWidth: 80 },
  { key: 'lastSync', label: 'Last Sync', sortKey: null, defaultWidth: 160, minWidth: 110 },
  { key: 'actions', label: 'Actions', sortKey: null, resizable: false, defaultWidth: 280, minWidth: 220, centerHeader: false },
];
export const XDR_INTEGRATION_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_xdr_integration_table_column_widths';

export const XDR_ALERTS_TABLE_COLUMNS = [
  { key: 'timestamp', label: 'Timestamp', sortKey: null, defaultWidth: 160, minWidth: 110 },
  { key: 'severity', label: 'Severity', sortKey: null, defaultWidth: 100, minWidth: 72 },
  { key: 'rule', label: 'Rule', sortKey: null, defaultWidth: 240, minWidth: 140 },
  { key: 'asset', label: 'Asset', sortKey: null, defaultWidth: 140, minWidth: 90 },
  { key: 'agent', label: 'Agent', sortKey: null, defaultWidth: 140, minWidth: 90 },
  { key: 'actions', label: 'Actions', sortKey: null, resizable: false, defaultWidth: 260, minWidth: 200, centerHeader: false },
];
export const XDR_ALERTS_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_xdr_alerts_table_column_widths';

export const SECURITY_EVENTS_TABLE_COLUMNS = [
  { key: 'title', label: 'Event', sortKey: null, defaultWidth: 240, minWidth: 140 },
  { key: 'asset', label: 'Asset', sortKey: null, defaultWidth: 160, minWidth: 100 },
  { key: 'severity', label: 'Severity', sortKey: null, defaultWidth: 110, minWidth: 80 },
  { key: 'confidence', label: 'Confidence', sortKey: null, defaultWidth: 120, minWidth: 90 },
  { key: 'timestamp', label: 'Timestamp', sortKey: null, defaultWidth: 180, minWidth: 120 },
  { key: 'actions', label: 'Actions', sortKey: null, resizable: false, defaultWidth: 120, minWidth: 96, centerHeader: false },
];
export const SECURITY_EVENTS_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_security_events_table_column_widths';

export const DEPLOYMENT_TOKEN_TABLE_COLUMNS = [
  { key: 'scanner', label: 'Scanner', sortKey: null, defaultWidth: 160, minWidth: 100 },
  { key: 'type', label: 'Type', sortKey: null, defaultWidth: 140, minWidth: 90 },
  { key: 'status', label: 'Status', sortKey: null, defaultWidth: 110, minWidth: 80 },
  { key: 'preview', label: 'Preview', sortKey: null, defaultWidth: 140, minWidth: 90 },
  { key: 'expires', label: 'Expires', sortKey: null, resizable: false, defaultWidth: 160, minWidth: 110 },
];
export const DEPLOYMENT_TOKEN_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_deployment_token_table_column_widths';

export const DEPLOYMENT_ATTEMPT_TABLE_COLUMNS = [
  { key: 'installId', label: 'Install ID', sortKey: null, defaultWidth: 180, minWidth: 120 },
  { key: 'status', label: 'Status', sortKey: null, defaultWidth: 110, minWidth: 80 },
  { key: 'host', label: 'Host fingerprint', sortKey: null, defaultWidth: 140, minWidth: 90 },
  { key: 'lastCheckIn', label: 'Last check-in', sortKey: null, resizable: false, defaultWidth: 160, minWidth: 110 },
];
export const DEPLOYMENT_ATTEMPT_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_deployment_attempt_table_column_widths';

export const SUBSCRIPTION_ORG_TABLE_COLUMNS = [
  { key: 'name', label: 'Organization', sortKey: 'name', defaultWidth: 240, minWidth: 160 },
  {
    key: 'status',
    label: 'Status',
    sortKey: 'status',
    defaultWidth: 110,
    minWidth: 90,
    maxWidth: 140,
    thClassName: 'subscription-org-select-th-status',
    tdClassName: 'subscription-org-select-td-status',
  },
  {
    key: 'plan',
    label: 'Plan',
    sortKey: 'plan',
    defaultWidth: 200,
    minWidth: 140,
    thClassName: 'subscription-org-select-th-plan',
    tdClassName: 'subscription-org-select-td-plan',
  },
  {
    key: 'sites',
    label: 'Sites',
    sortKey: 'sites',
    defaultWidth: 90,
    minWidth: 70,
    maxWidth: 110,
    centerHeader: true,
    thClassName: 'subscription-org-select-th-sites',
    tdClassName: 'subscription-org-select-td-sites',
  },
  {
    key: 'trialEnds',
    label: 'Trial ends',
    sortKey: 'trialEnds',
    defaultWidth: 140,
    minWidth: 110,
    thClassName: 'subscription-org-select-th-trial',
    tdClassName: 'subscription-org-select-td-trial',
  },
  {
    key: 'actions',
    label: '',
    sortKey: null,
    resizable: false,
    defaultWidth: 220,
    minWidth: 200,
    maxWidth: 260,
    thClassName: 'subscription-org-select-th-actions',
    tdClassName: 'subscription-org-select-td-actions',
  },
];
export const SUBSCRIPTION_ORG_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_subscription_org_table_column_widths_v7';

export const SUBSCRIPTION_SITE_TABLE_COLUMNS = [
  { key: 'name', label: 'Site Name', sortKey: 'name', defaultWidth: 200, minWidth: 120 },
  { key: 'plan', label: 'Plan', sortKey: null, defaultWidth: 120, minWidth: 90 },
  { key: 'perimeter', label: 'Perimeter IPs', sortKey: 'perimeter', defaultWidth: 160, minWidth: 110 },
  { key: 'onPrem', label: 'On-Premise IPs', sortKey: 'onPrem', defaultWidth: 160, minWidth: 110 },
  { key: 'web', label: 'Web App FQDNs', sortKey: 'web', defaultWidth: 160, minWidth: 110 },
];
export const SUBSCRIPTION_SITE_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_subscription_site_table_column_widths';

export const INVOICES_TABLE_COLUMNS = [
  { key: 'number', label: 'Invoice #', sortKey: null, defaultWidth: 140, minWidth: 100 },
  { key: 'period', label: 'Billing Period', sortKey: null, defaultWidth: 180, minWidth: 120 },
  { key: 'amount', label: 'Amount', sortKey: null, defaultWidth: 100, minWidth: 80 },
  { key: 'status', label: 'Status', sortKey: null, defaultWidth: 110, minWidth: 80 },
  { key: 'date', label: 'Date', sortKey: null, defaultWidth: 120, minWidth: 90 },
  { key: 'links', label: 'Action', sortKey: null, resizable: false, defaultWidth: 120, minWidth: 90, thClassName: 'invoices-th-action' },
];
export const INVOICES_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_invoices_table_column_widths';

export const PLAN_REVIEW_TABLE_COLUMNS = [
  { key: 'capacity', label: 'Capacity', sortKey: null, defaultWidth: 180, minWidth: 120 },
  { key: 'current', label: 'Current', sortKey: null, defaultWidth: 100, minWidth: 72 },
  { key: 'requested', label: 'Requested', sortKey: null, defaultWidth: 100, minWidth: 72 },
];
export const PLAN_REVIEW_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_plan_review_table_column_widths';

export const USERS_ORGS_USER_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_users_orgs_user_table_column_widths_v2';
export const USERS_ORGS_ORG_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_users_orgs_org_table_column_widths_v2';

export function getUsersOrgsTableColumns({ isUsersTab }) {
  const cols = [
    {
      key: 'checkbox',
      sortKey: null,
      resizable: false,
      defaultWidth: 44,
      minWidth: 44,
      centerHeader: true,
      thClassName: 'users-orgs-settings-th-checkbox',
    },
    {
      key: 'name',
      label: 'Name',
      sortKey: 'name',
      defaultWidth: 160,
      minWidth: 100,
      sortButtonClassName: USERS_ORGS_SORT_BTN,
      sortIconClassName: USERS_ORGS_SORT_ICON,
    },
  ];
  if (isUsersTab) {
    cols.push({
      key: 'organization',
      label: 'Organization',
      sortKey: 'organization',
      defaultWidth: 160,
      minWidth: 100,
      sortButtonClassName: USERS_ORGS_SORT_BTN,
      sortIconClassName: USERS_ORGS_SORT_ICON,
    });
  }
  cols.push(
    {
      key: 'perimeter',
      label: 'Perimeter (30d)',
      sortKey: 'perimeter',
      defaultWidth: 150,
      minWidth: 110,
      sortButtonClassName: USERS_ORGS_SORT_BTN,
      sortIconClassName: USERS_ORGS_SORT_ICON,
    },
    {
      key: 'onprem',
      label: 'On-prem (30d)',
      sortKey: 'onprem',
      defaultWidth: 150,
      minWidth: 110,
      sortButtonClassName: USERS_ORGS_SORT_BTN,
      sortIconClassName: USERS_ORGS_SORT_ICON,
    },
    {
      key: 'created',
      label: 'Created',
      sortKey: 'created',
      defaultWidth: 170,
      minWidth: 120,
      sortButtonClassName: USERS_ORGS_SORT_BTN,
      sortIconClassName: USERS_ORGS_SORT_ICON,
    },
    {
      key: 'actions',
      label: 'Actions',
      sortKey: null,
      resizable: false,
      defaultWidth: 120,
      minWidth: 100,
      maxWidth: 160,
      centerHeader: false,
      thClassName: 'users-orgs-settings-th-actions',
    }
  );
  return cols;
}

export function getScansTableColumns({
  showNetworkTypeColumn,
  showScanKindColumn = false,
  showCheckboxColumn = true,
  recordView = 'runs',
  showOrgSiteColumn = true,
}) {
  const cols = [];
  const isSchedules = recordView === 'schedules';
  if (showCheckboxColumn) {
    cols.push({
      key: 'check',
      sortKey: null,
      resizable: false,
      defaultWidth: 44,
      minWidth: 44,
      maxWidth: 44,
      centerHeader: true,
      thClassName: 'scans-check-th',
      colClassName: 'scans-col-check',
    });
  }
  cols.push({ key: 'scanName', label: 'Scan name / Target', sortKey: 'scanName', defaultWidth: 240, minWidth: 160, colClassName: 'scans-col-name' });
  if (showOrgSiteColumn) {
    cols.push({ key: 'orgSite', label: 'Organization / Site', sortKey: 'orgName', defaultWidth: 170, minWidth: 130, colClassName: 'scans-col-orgsite' });
  }
  if (showScanKindColumn) {
    cols.push({ key: 'scanKind', label: 'Type', sortKey: 'scanType', defaultWidth: 110, minWidth: 90, colClassName: 'scans-col-kind' });
  }
  if (showNetworkTypeColumn) {
    cols.push({ key: 'networkType', label: showScanKindColumn ? 'Network' : 'Location', sortKey: 'networkType', defaultWidth: 120, minWidth: 100, colClassName: 'scans-col-type' });
  }
  cols.push({ key: 'status', label: 'Status', sortKey: 'status', defaultWidth: 130, minWidth: 110, colClassName: 'scans-col-status' });
  if (isSchedules) {
    cols.push(
      { key: 'nextRunAt', label: 'Next run', sortKey: 'nextRunAt', defaultWidth: 140, minWidth: 120, colClassName: 'scans-col-datetime' },
      { key: 'recurrence', label: 'Recurrence', sortKey: 'recurrence', defaultWidth: 120, minWidth: 100, colClassName: 'scans-col-recurrence' }
    );
  } else {
    cols.push(
      { key: 'startedAt', label: 'Started at', sortKey: 'startedAt', defaultWidth: 140, minWidth: 120, colClassName: 'scans-col-datetime' },
      { key: 'completedAt', label: 'Completed at', sortKey: 'completedAt', defaultWidth: 140, minWidth: 120, colClassName: 'scans-col-datetime' },
      { key: 'risks', label: 'Severity', sortKey: 'risks', defaultWidth: 200, minWidth: 170, thClassName: 'scans-risks-th', sortButtonClassName: 'assets-sort-btn scans-risks-th-btn', colClassName: 'scans-col-risks' }
    );
  }
  cols.push(
    { key: 'actions', label: 'Actions', sortKey: null, resizable: false, defaultWidth: 84, minWidth: 84, maxWidth: 84, centerHeader: false, thClassName: 'scans-actions-th', colClassName: 'scans-col-actions' }
  );
  return cols;
}
export const SCANS_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_scans_table_column_widths_v5';
export const SCANS_TABLE_COLUMN_WIDTHS_KEY_WEB = 'xspectre_scans_table_column_widths_web_v5';
export const SCANS_TABLE_COLUMN_WIDTHS_KEY_NETWORK = 'xspectre_scans_table_column_widths_network_v5';

export const SUPPORT_TICKET_TABLE_COLUMNS = [
  { key: 'ticket', label: 'Ticket', sortKey: null, defaultWidth: 180, minWidth: 120 },
  { key: 'subject', label: 'Subject', sortKey: null, defaultWidth: 280, minWidth: 160 },
  { key: 'status', label: 'Status', sortKey: null, defaultWidth: 130, minWidth: 100 },
  { key: 'priority', label: 'Priority', sortKey: null, defaultWidth: 120, minWidth: 90 },
  { key: 'created', label: 'Created', sortKey: null, resizable: false, defaultWidth: 190, minWidth: 140 },
];
export const SUPPORT_TICKET_TABLE_COLUMN_WIDTHS_KEY = 'xspectre_support_ticket_table_column_widths';
